// extracted by mini-css-extract-plugin
export default {"mobileCard":"paperJournalRowDataList_mobileCard__p2EWd","fileHash":"paperJournalRowDataList_fileHash__CvAG1"};